const TERMINAL_LIFECYCLES = new Set(["closed", "cancelled"]);

export function isTopicOpen(item) {
  return !TERMINAL_LIFECYCLES.has(item?.topic?.lifecycle);
}

export function isTopicOverdue(item) {
  if (!isTopicOpen(item) || !item?.topic?.dueAt) return false;
  const dueAt = new Date(item.topic.dueAt).getTime();
  return Number.isFinite(dueAt) && dueAt < Date.now();
}

function topicDueTime(item) {
  const dueAt = new Date(item?.topic?.dueAt).getTime();
  return Number.isFinite(dueAt) ? dueAt : Number.POSITIVE_INFINITY;
}

export function filterTopics(items, filter) {
  return items.filter((item) => {
    const topic = item?.topic || {};
    if (filter === "open") return isTopicOpen(item);
    if (filter === "new") return isTopicOpen(item) && Boolean(item.unread);
    if (filter === "critical") return isTopicOpen(item) && topic.criticality === "critical";
    if (filter === "closed") return TERMINAL_LIFECYCLES.has(topic.lifecycle);
    return true;
  }).sort((left, right) => {
    const criticalDelta = Number(right?.topic?.criticality === "critical" && right.unread)
      - Number(left?.topic?.criticality === "critical" && left.unread);
    if (criticalDelta) return criticalDelta;
    const overdueDelta = Number(isTopicOverdue(right)) - Number(isTopicOverdue(left));
    if (overdueDelta) return overdueDelta;
    const unreadDelta = Number(Boolean(right.unread)) - Number(Boolean(left.unread));
    if (unreadDelta) return unreadDelta;
    const dueDelta = topicDueTime(left) - topicDueTime(right);
    if (dueDelta) return dueDelta;
    return new Date(right.updatedAt || 0) - new Date(left.updatedAt || 0);
  });
}

export function notificationPage(topics, page = 0) {
  const unread = filterTopics(topics, "new");
  const lastPage = Math.max(0, Math.ceil(unread.length / 5) - 1);
  const currentPage = Math.max(0, Math.min(page, lastPage));
  return {
    items: unread.slice(currentPage * 5, currentPage * 5 + 5),
    count: unread.length,
    page: currentPage,
    hasMore: currentPage < lastPage,
  };
}